export const ActivityModality = Object.freeze({
  DIGITAL: "digital",
  PHYSICAL: "physical",
  EITHER: "either",
});
